module.exports = __webpack_public_path__ + "static/media/0.d2374256.png";